import { selectors as AccountSelectors } from '../entities/Account';
import { selectors as ProfileSelectors } from '../entities/Profile';

export const getSwitchesFromState = state => {
  const currentAccount = AccountSelectors.all.currentAccount(state);
  const currentProfile = ProfileSelectors.all.currentProfile(state);

  const accountSwitches =
    currentAccount && currentAccount.data && currentAccount.data.switches
      ? currentAccount.data.switches
      : {};
  const profileSwitches =
    currentProfile && currentProfile.data && currentProfile.data.switches
      ? currentProfile.data.switches
      : {};

  return {
    ...accountSwitches,
    ...profileSwitches,
  };
};
